import { useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";

import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import { Cake, PenLine, Play, Rocket, Ticket } from "lucide-react";
import VideoModal from "../../components/modal/VideoModal";
import { ChallengeScheme, EventScheme, ProductScheme } from "client-v2";

const Container = styled.div``;
const DesktopSection = styled.div`
	${media.lessThan("medium")`
        display: none;
    `}
`;
const MobileSection = styled.div`
	display: none;
	flex: 1;
	flex-direction: column;
	${media.lessThan("medium")`
        display: flex;
    `}
`;
const Title = styled(Text)`
	display: none;
	${media.lessThan("medium")`
        display: flex;
    `}
`;
const EventImage = styled.img`
	position: absolute;
	height: 100%;
	width: 100%;
	object-fit: cover;
`;
const EventImageView = styled.div`
	position: relative;
	display: flex;
	aspect-ratio: 4/3;
	border-radius: 12px;
	width: -webkit-fill-available;
	width: -moz-available;
	overflow: hidden;
	${media.lessThan("medium")`
        border-radius: 0px;
        aspect-ratio: 4/3;
    `}
`;
const PlayButton = styled.div`
	position: absolute;
	bottom: 24px;
	right: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50px;
	padding: 6px 12px;
	gap: 6px;
	background-color: #0000003d;
	${media.lessThan("medium")`
        bottom: 16px;
        right: 16px;
    `}
`;
const Chip = styled.div`
	display: flex;
	padding: 6px 14px;
	border-radius: 20px;
	border: 1px solid ${ColorV2.border.neutralSoft};
	width: fit-content;
	align-items: center;
	justify-content: center;
	gap: 6px;
	margin-bottom: 16px;
`;

const Header = (props: PropsChallenge | PropsEvent) => {
	const [showVideo, setShowVideo] = useState(false);

	return (
		<Container>
			{(props.challenge?.video || props.event?.video) && (
				<VideoModal
					isVisible={showVideo}
					url={
						props.challenge?.video
							? props.challenge.video
							: props.event?.video
							? props.event.video
							: ""
					}
					onFinish={() => setShowVideo(false)}
					onClose={() => setShowVideo(false)}
				/>
			)}
			<MobileSection style={{ margin: "-24px -24px 32px" }}>
				<EventImageView
					onClick={() =>
						(props.challenge?.video || props.event?.video) &&
						setShowVideo(true)
					}
				>
					<EventImage
						src={
							props.challenge?.image.url || props.event?.image.url
						}
					/>
					{props.challenge?.video ||
						(props.event?.video && (
							<PlayButton>
								<Play
									height={24}
									width={24}
									fill={"white"}
									strokeWidth={0}
								/>
								<Text type="b2" style={{ color: "white" }}>
									Ver video
								</Text>
							</PlayButton>
						))}
				</EventImageView>
			</MobileSection>
			<MobileSection>
				<Chip>
					{props.challenge?.type === "signature" ? (
						<PenLine
							height={20}
							width={20}
							color={ColorV2.text.neutralHard}
						/>
					) : props.challenge?.type === "birthday" ? (
						<Cake
							height={20}
							width={20}
							color={ColorV2.text.neutralHard}
						/>
					) : props.challenge?.type === "dream" ? (
						<Rocket
							height={20}
							width={20}
							color={ColorV2.text.neutralHard}
						/>
					) : (
						<Ticket
							height={20}
							width={20}
							color={ColorV2.text.neutralHard}
						/>
					)}
					<Text type="p2">
						{props.challenge?.type === "signature"
							? "Firma"
							: props.challenge?.type === "birthday"
							? "Cumpleaños"
							: props.challenge?.type === "dream"
							? "Sueño"
							: "Evento"}
					</Text>
				</Chip>
				<Title type="h3" weight="semibold">
					{props.challenge?.title || props.product?.title}
				</Title>
			</MobileSection>
			<DesktopSection
				style={{
					cursor:
						props.challenge?.video || props.event?.video
							? "pointer"
							: "default",
				}}
				onClick={() =>
					props.challenge?.video ||
					(props.event?.video && setShowVideo(true))
				}
			>
				<EventImageView>
					<EventImage
						src={
							props.challenge?.image.url || props.event?.image.url
						}
					/>
					{props.challenge?.video ||
						(props.event?.video && (
							<PlayButton>
								<Play
									height={24}
									width={24}
									fill={"white"}
									strokeWidth={0}
								/>
								<Text type="b2" style={{ color: "white" }}>
									Ver video
								</Text>
							</PlayButton>
						))}
				</EventImageView>
			</DesktopSection>
		</Container>
	);
};
export default Header;
export interface PropsChallenge {
	event?: undefined;
	product?: undefined;
	challenge: ChallengeScheme;
}
export interface PropsEvent {
	event: EventScheme;
	product: ProductScheme;
	challenge?: undefined;
}
